import {
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.css',
})
export class PopupComponent implements AfterViewInit {
  @Input() title: string = '';
  @Input() primaryButtonText: string = '';
  @Input() secondaryButtonText: string = '';
  @Input() helpButtonText: string = '';
  @Input() showClose: boolean = true;
  @Input() showHeader: boolean = true;
  @Input() secondaryButtonFlat: boolean = false;
  @Input() primaryButtonFlat: boolean = false;
  @Input() helpButtonFlat: boolean = false;
  @Input() imageUrl: string = '';
  @Input() showImage: boolean = false;
  @Input() draggable: boolean = false;
  @Input() isSecondaryButtonDisabled: boolean = false;
  @Input() isPrimaryButtonDisabled: boolean = false;
  @Input() overflow: 'auto' | 'hidden' | 'visible' = 'auto';

  @Output() closeClicked = new EventEmitter<void>();
  @Output() primaryButtonClicked = new EventEmitter<void>();
  @Output() secondaryButtonClicked = new EventEmitter<void>();
  @Output() onhelpButtonClicked = new EventEmitter<void>();

  position = { x: 0, y: 0 };
  private resizeObserver?: ResizeObserver;
  private isDragging = false;
  private startX = 0;
  private startY = 0;

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    const modal = this.el.nativeElement.querySelector('.modal-content');
    if (modal) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { width, height } = entry.contentRect;
          this.centerModal(width, height);
        }
      });
      this.resizeObserver.observe(modal);
    }
  }

  private centerModal(width: number, height: number) {
    this.position.x = (window.innerWidth - width) / 2;
    this.position.y = (window.innerHeight - height) / 2;
    this.cdr.detectChanges();
  }

  onDragStart(event: MouseEvent) {
    if (!this.draggable) return;
    event.preventDefault();
    this.isDragging = true;
    this.startX = event.clientX - this.position.x;
    this.startY = event.clientY - this.position.y;
    document.body.classList.add('no-select');
  }

  @HostListener('document:mousemove', ['$event'])
  onDragging(event: MouseEvent) {
    if (!this.isDragging) return;

    const modal = this.el.nativeElement.querySelector('.modal-content');
    const rect = modal.getBoundingClientRect();

    let newX = event.clientX - this.startX;
    let newY = event.clientY - this.startY;

    const maxX = window.innerWidth - rect.width;
    const maxY = window.innerHeight - rect.height;

    newX = Math.max(0, Math.min(newX, maxX));
    newY = Math.max(0, Math.min(newY, maxY));

    this.position.x = newX;
    this.position.y = newY;
  }

  @HostListener('document:mouseup')
  stopDragging() {
    this.isDragging = false;
    document.body.classList.remove('no-select');
  }

  onCloseClicked(event: MouseEvent) {
    event.stopPropagation();
    this.closeClicked.emit();
  }

  onPrimaryButtonClicked(event: MouseEvent) {
    event.stopPropagation();
    this.primaryButtonClicked.emit();
  }

  onSecondaryButtonClicked(event: MouseEvent) {
    event.stopPropagation();
    this.secondaryButtonClicked.emit();
  }

  onHelpButtonClicked(event: MouseEvent) {
    event.stopPropagation();
    this.onhelpButtonClicked.emit();
  }
}
